import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { IHeroEventListResolverData } from './hero-event-list-models/hero-event-list-resolver-data.interface';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppEventService } from '../events.service';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppHeroEventsListResolver extends BaseResolver<IHeroEventListResolverData> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public eventService: AppEventService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(): Promise<IHeroEventListResolverData> {
    return this.eventService.getHeroEventsResolverData();
  }
}
